import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import { Button, Fade, Typography } from '@mui/material';
import { BlockOutlined as ErrorIcon } from '@mui/icons-material';
import Centered from '../../../layouts/Centered';
const Root = styled('div')(({ theme }) => ({
    borderWidth: 1,
    borderStyle: 'dashed',
    borderColor: theme.palette.primary.main,
    width: 400,
    borderRadius: theme.spacing(1),
    padding: theme.spacing(8),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
}));
const Container = styled('div')(() => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
}));
const Text = styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
}));
const Icon = styled(ErrorIcon)(({ theme }) => ({
    color: theme.palette.primary.main,
    width: theme.spacing(14),
    height: theme.spacing(14),
    marginRight: theme.spacing(2),
}));
const Action = styled('div')(({ theme }) => ({
    marginTop: theme.spacing(2),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
}));
const NotAuthorised = ({ goBack }) => {
    const handleBack = () => {
        goBack(-1);
    };
    return (_jsx(Centered, { children: _jsx(Fade, Object.assign({ in: true, timeout: 1700 }, { children: _jsxs(Root, { children: [_jsxs(Container, { children: [_jsx(Icon, { color: "primary" }), _jsxs(Text, { children: [_jsx(Typography, Object.assign({ variant: "h2", color: "primary" }, { children: "401" })), _jsx(Typography, Object.assign({ variant: "subtitle2", color: "primary" }, { children: "page not authorised" }))] })] }), _jsx(Action, { children: _jsx(Button, Object.assign({ fullWidth: true, variant: "outlined", color: "primary", onClick: handleBack }, { children: "go back" })) })] }) })) }));
};
export default NotAuthorised;
//# sourceMappingURL=index.js.map